// firbase config file 
const firebaseConfig = {
    apiKey: "AIzaSyDao6S2MLZ-Lldn9nhtQ9zPCFRwnWFEqfo",
    authDomain: "mental-carevio.firebaseapp.com",
    projectId: "mental-carevio",
    storageBucket: "mental-carevio.appspot.com",
    messagingSenderId: "83645448117",
    appId: "1:83645448117:web:afcaf7874458120d7d23fc"
};
export default firebaseConfig;